import { render, staticRenderFns } from "./Sf-check.vue?vue&type=template&id=13523b94"
import script from "./Sf-check.vue?vue&type=script&lang=js"
export * from "./Sf-check.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports